import React, { useRef, useEffect } from "react";
import { useSearchParams } from "react-router-dom";

function Paginate({
  totalCount,
  itemsPerPage,
  offset,
  setSearchParams,
  children,
  isDisabled = false,
}) {
  const numerator = parseInt(itemsPerPage) * parseInt(offset) + 1;
  const denominator = parseInt(itemsPerPage) * (parseInt(offset) + 1);
  const lastPage = totalCount / itemsPerPage + 1;

  return (
    <div>
      {lastPage - 2 > 0 && numerator && !isDisabled && (
        <>
          <p className="small text-muted">
            Showing {numerator} -{" "}
            {denominator > totalCount ? totalCount : denominator} of{" "}
            {totalCount} records
          </p>
          <hr />
        </>
      )}

      {children}
      {!isDisabled && lastPage - 2 > 0 && (
        <nav aria-label="Page navigation example" className="mt-5">
          <ul className="pagination">
            <li className="page-item">
              <span
                className="page-link"
                onClick={() =>
                  parseInt(offset) > 0 &&
                  setSearchParams({
                    offset: parseInt(offset) - 1,
                    limit: itemsPerPage,
                  })
                }
              >
                Previous
              </span>
            </li>

            {Array.from({ length: lastPage }).map((el, i) => (
              <li
                className={`page-item ${offset == i && "active"}`}
                key={`page_${i}`}
              >
                <span
                  className="page-link"
                  onClick={() =>
                    setSearchParams({
                      offset: i,
                      limit: itemsPerPage,
                    })
                  }
                >
                  {i + 1}
                </span>
              </li>
            ))}
            <li className="page-item">
              <span
                className="page-link"
                onClick={() =>
                  parseInt(offset) + 1 < parseInt(Math.ceil(lastPage)) - 1 &&
                  setSearchParams({
                    offset: parseInt(offset) + 1,
                    limit: itemsPerPage,
                  })
                }
              >
                Next
              </span>
            </li>
          </ul>
        </nav>
      )}
    </div>
  );
}

export default Paginate;
